import { EventStreamDataset, Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.eventStream.copySourceType,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.EventStream_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.EventStream_DisplayText)
    ],
    tags: { datasetModel: Metamodel.modelFor(EventStreamDataset) }
})
export class EventStreamCopySource extends TabularCopySource {}
